import { useNavigate } from "react-router-dom";
import { useNetworkScope } from "../../hooks/useNetworkScope";
import { useUser } from "../../hooks/useUser";
import { isInternal } from "../../utils";

// Opens the strategy wizard from a Consumer Voice (?cv=) or AI Presence
// (?aip=) analysis; the wizard asks the server to suggest the category and
// objectives from that report. Inside a brand-portal workspace everyone uses
// the brand's own wizard; internal users elsewhere land on /proposal (the
// product list's convention).
export const useStrategyFromAnalysis = () => {
    const navigate = useNavigate();
    const { role } = useUser();
    const { basePath, inWorkspace } = useNetworkScope();
    return (
        source: "cv" | "aip",
        audit: { id: number; desireid?: number | null },
        productTitle?: string | null,
    ) => {
        const params = new URLSearchParams({ [source]: String(audit.id) });
        if (audit.desireid) params.set("desireid", String(audit.desireid));
        if (productTitle) params.set("title", productTitle);
        const path = inWorkspace || !isInternal(role) ? `${basePath}/opportunities/strategies/new` : "/proposal";
        navigate(`${path}?${params.toString()}`);
    };
};
